import { TRACKING_CURRENCY } from '../../const';
import { getCartItemsTracking } from '../../helpers';

import type { RootState } from 'core/store';

export const cartBeginCheckout = (prevState: RootState) => ({
  event: 'begin_checkout',
  ecommerce: {
    currency: TRACKING_CURRENCY,
    value: prevState.cart.data?.totalNum,
    items: getCartItemsTracking(prevState),
    coupon: prevState.cart.data?.coupon?.description || '',
  },
});
